import type { MachineResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { repository } from "~/clientInstance";
import { MachineConnectivityPage } from "./MachineConnectivityPage";
type DeploymentTargetConnectivityPageProps = {
    machineId: string;
};
export function DeploymentTargetConnectivityPage({ machineId }: DeploymentTargetConnectivityPageProps) {
    return <MachineConnectivityPage repository={repository.Machines} itemDescription={"deployment target"} getConnectionStatus={(machine: MachineResource) => repository.Machines.getConnectionStatus(machine)} machineId={machineId}/>;
}
